import { render, staticRenderFns } from "./msCard.vue?vue&type=template&id=96a1a17e"
import script from "./msCard.vue?vue&type=script&lang=js"
export * from "./msCard.vue?vue&type=script&lang=js"
import style0 from "./msCard.vue?vue&type=style&index=0&id=96a1a17e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports